module.exports = __webpack_public_path__ + "static/media/aangenaam-menno-logo.6876a5fb.png";